import * as ActionTypes from '../ActionTypes'
import {
  RegisterPartnerService,
  LoginUserService,
  LogOutUserService,
} from '../../services/AuthServices'

export const RegisterPartnerAction = (credentials) => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.RESTART_AUTH_RESPONSE })
    dispatch({ type: ActionTypes.LOADING })

    RegisterPartnerService(credentials).then(
      (res) => {
        if (
          Object.prototype.hasOwnProperty.call(res, 'success') &&
          res.success === true
        ) {
          dispatch({ type: ActionTypes.REGISTERPARTNER_SUCCESS, res })
        } else if (
          Object.prototype.hasOwnProperty.call(res, 'success') &&
          res.success === false
        ) {
          dispatch({ type: ActionTypes.REGISTERPARTNER_ERROR, res })
        }
      },
      (error) => {
        dispatch({ type: ActionTypes.CODE_ERROR, error })
      },
    )
  }
}

export const LoginAction = (credentials, history) => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.RESTART_AUTH_RESPONSE })
    dispatch({ type: ActionTypes.LOADING })
    LoginUserService(credentials).then(
      (res) => {
        if (
          Object.prototype.hasOwnProperty.call(res, 'success') &&
          res.success === true
        ) {
          localStorage.setItem('user-token', res.token)
          dispatch({ type: ActionTypes.LOGIN_SUCCESS })
          setTimeout(() => {
            history.push('/view-profile')
          }, 1500)
        } else if (
          Object.prototype.hasOwnProperty.call(res, 'success') &&
          res.success === false
        ) {
          dispatch({ type: ActionTypes.LOGIN_ERROR, res })
        }
      },
      (error) => {
        dispatch({ type: ActionTypes.CODE_ERROR, error })
      },
    )
  }
}

export const LogoutAction = () => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.RESTART_AUTH_RESPONSE })

    LogOutUserService().then(
      (res) => {
        if (
          Object.prototype.hasOwnProperty.call(res, 'success') &&
          res.success === true
        ) {
          dispatch({ type: ActionTypes.LOGOUT_SUCCESS, res })
        } else if (
          Object.prototype.hasOwnProperty.call(res, 'success') &&
          res.success === false
        ) {
          dispatch({ type: ActionTypes.LOGOUT_SUCCESS, res })
        }
      },
      (error) => {
        dispatch({ type: ActionTypes.CODE_ERROR, error })
      },
    )
  }
}
